// const new_service_basis = window.gtaAiConfig.service_basis

 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let service_data=getEnv(tag).service_data

export default {
  // 标注项目接口
  /**
   * 获取编辑器的积木列表
   */
  getBlockList: `${new_service_basis}/ai/training/editor/getBlockList`,
  /**
   * 获取编辑器的部分积木列表---我的模型、公共模型部分
   */
   getModelBlockList: `${new_service_basis}/ai/training/editor/getModelBlockList`,

  /**
   *查询媒体积木
   */
  getMediaByTrainingId: `${new_service_basis}/ai/training/editor/getMediaByTrainingId`,
  /**
   * 新增媒体积木
   */
  insertMedia: `${new_service_basis}/ai/training/editor/insertMedia`,

  /**
   *  修改媒体积木
   */
  updateMedia: `${new_service_basis}/ai/training/editor/updateMedia`,
  /**
   *   删除媒体积木
   */
  deleteMedia: `${new_service_basis}/ai/training/editor/deleteMedia`,


};
